export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-200px.jpg.b54f8575.webp";